import React, { useState } from 'react';
import Modal from '@common/modal';
import LoadingIcon from '@common/loadingIcon';
import { useMessageActions } from '@stores/zustand/MessageStore';
import { useUploadApplicationFiles } from '@repository/match';
import { FileSubmitErrorType } from '../index';
import classnames from 'classnames/bind';
import styles from './fileAttachmentConfirmModal.module.scss';

const cx = classnames.bind(styles);

interface FileAttachmentConfirmModal {
  visible: boolean;
  onClose: () => void;
  filesState: File[];
  positionSn: number | null;
  optionSn: string | null;
  handleErrors: (errorCode: FileSubmitErrorType) => void;
}

const FileAttachmentConfirmModal = ({
  visible,
  onClose,
  filesState,
  positionSn,
  optionSn,
  handleErrors,
}: FileAttachmentConfirmModal) => {
  const { mutateAsync: uploadApplicationFiles } = useUploadApplicationFiles();
  const [isLoading, setIsLoading] = useState(false);
  const { fetchMessagesList } = useMessageActions();

  const handleSubmit = async () => {
    if (!positionSn || !optionSn || isLoading) return;
    setIsLoading(true);
    try {
      await uploadApplicationFiles({ positionSn, optionSn: Number(optionSn), files: filesState });
      onClose();
      await fetchMessagesList(positionSn);
    } catch (e: any) {
      handleErrors(e);
    } finally {
      setIsLoading(false);
    }
  };

  const filesEl = filesState.map((file, index) => {
    return (
      <div key={index} className={cx('fileName')}>
        {file.name}
      </div>
    );
  });

  return (
    <Modal visible={visible} isUseScrollHidden={false}>
      <div className={cx('layer')}>
        <strong className={cx('title')}>파일을 제출하시겠어요?</strong>

        <div className={cx('fileConfirmArea')}>
          <div className={cx('fileConfirmInner')}>
            <div className={cx('fileConfirmWrap')}>{filesEl}</div>
          </div>
        </div>

        <div className={cx('descArea')}>
          <p className={cx('desc')}>제출하시는 내용을 잘 확인하셨나요?</p>
          <p className={cx('notice')}>*최종 제출 이후에는 수정이 불가능합니다.</p>
        </div>

        <div className={cx('btnArea')}>
          <a className={cx('btn', 'btnCancel')} role="button" onClick={onClose}>
            아니오
          </a>
          {isLoading ? (
            <a className={cx('btn', 'btnConfirm')}>
              <LoadingIcon size={56} />
            </a>
          ) : (
            <a className={cx('btn', 'btnConfirm')} role="button" onClick={handleSubmit}>
              네, 제출할게요
            </a>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default FileAttachmentConfirmModal;
